import React from "react";
import { Box, BoxProps } from "@mui/material";
import { NO_ACTIVITY_EXERCISE_MESSAGE } from "../utils";

interface NoActivityExerciseMessageBoxProps extends BoxProps {}

export const NoActivityExerciseMessageBox = (
  props: NoActivityExerciseMessageBoxProps,
) => {
  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      width="100%"
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="flex-start"
      pt={13}
      bgcolor="rgba(255,255,255,0.6)"
      color="text.secondary"
      fontSize={17}
      fontWeight={500}
      fontFamily="'Montserrat', sans-serif"
      {...props}
    >
      {NO_ACTIVITY_EXERCISE_MESSAGE}
    </Box>
  );
};
